import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from "react";
import { Grid, makeStyles, SingleBarChart, StackedBarChart, BoxNumber } from "../../..";
import _ from "lodash";
import { StackedGroupBarChart } from "../../../Molecules/Charts/StackedGroupBarChart";
import numeral from "numeral";
var useStyles = makeStyles(function (theme) {
  return {
    justifiySpaceBetween: {
      "justify-content": "space-between"
    },
    justifiySpaceAround: {
      "justify-content": "space-around"
    },
    chartContainer: {
      margin: "20px",
      background: "#e8e8e81a",
      "align-items": "center",
      "justify-content": "space-between",
      "padding-top": "40px" // display: "flex",

    },
    boxContainer: {
      display: "flex",
      padding: "20px 0",
      "align-items": "flex-end"
    }
  };
});

var InvoicesData = function InvoicesData(_ref) {
  var dashboard = _ref.dashboard,
      translation = _ref.translation,
      franchise = _ref.franchise,
      groupedByCategory = _ref.groupedByCategory,
      locale = _ref.locale,
      data = _ref.data,
      compareYears = _ref.compareYears,
      years = _ref.years;
  // console.log("InvoicesData props", dashboard, data, franchise, translation);
  var classes = useStyles();

  var _useState = useState({
    initial_fee: 0,
    recurring_fee: 0,
    other: 0,
    marketplace: 0,
    marketing: 0,
    office: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      percentages = _useState2[0],
      setPercentages = _useState2[1]; // console.log("InvoicesData locale", locale);


  useEffect(function () {
    // console.log("dasboard changed", dashboard);
    dashboard && dashboard.initial_fee ? setPercentages({
      initial_fee: (dashboard.initial_fee / dashboard.total * 100).toFixed(2),
      recurring_fee: (dashboard.recurring_fee / dashboard.total * 100).toFixed(2),
      other: (dashboard.other / dashboard.total * 100).toFixed(2),
      marketplace: (dashboard.marketplace / dashboard.total * 100).toFixed(2) // office: ((dashboard.office / dashboard.total) * 100).toFixed(2),
      // marketing: ((dashboard.marketing / dashboard.total) * 100).toFixed(2),

    }) : dashboard && setPercentages({
      events: (dashboard.events / dashboard.total * 100).toFixed(2),
      campus: (dashboard.campus / dashboard.total * 100).toFixed(2),
      academies: (dashboard.academies / dashboard.total * 100).toFixed(2),
      other: (dashboard.other / dashboard.total * 100).toFixed(2)
    });
  }, [dashboard]);
  useEffect(function () {// console.log("data changed", data);
  }, [data]);

  var createTotalCompare = function createTotalCompare() {
    var numItems = Object.keys(dashboard).filter(function (key) {
      return key.includes("total_");
    }).filter(function (key) {
      return years.includes(key.split("_")[1]);
    });
    numItems.sort();
    return numItems.map(function (item, index, arr) {
      return /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12 / numItems.length
      }, /*#__PURE__*/React.createElement(BoxNumber, {
        total: true,
        variant: index > 0 ? "percentage" : null,
        percentage: numeral((dashboard[item] - dashboard[arr[0]]) / dashboard[arr[0]] * 100).format("0"),
        value: dashboard[item],
        title: "Total ".concat(item.split("_")[1]),
        locale: locale
      }));
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12,
    className: [classes.charts, classes.chartContainer].join(" ")
  }, dashboard && (compareYears ? /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, createTotalCompare()) : /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3,
    lg: 12
  }, /*#__PURE__*/React.createElement(BoxNumber, {
    total: true,
    value: dashboard.total,
    title: translation && translation.dashboard.total ? translation.dashboard.total : "Total",
    locale: locale
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12,
    lg: 12
  }, data && !franchise && !groupedByCategory && (compareYears ? /*#__PURE__*/React.createElement(StackedGroupBarChart, {
    key: years.join("_"),
    height: 370,
    dataRaw: data,
    acc: "subtotal",
    stackedBy: "dateCategory",
    groups: years // brush
    ,
    label: true,
    legend: true,
    locale: locale
  }) : /*#__PURE__*/React.createElement(SingleBarChart, {
    data: data,
    height: 370,
    groupedBy: "date",
    groups: years,
    acc: "subtotal" // brush
    ,
    label: true,
    locale: locale
  })), data && (franchise || !franchise && groupedByCategory) && (compareYears ? /*#__PURE__*/React.createElement(StackedGroupBarChart, {
    key: years.join("_"),
    height: 370,
    dataRaw: data,
    acc: "subtotal",
    stackedBy: "dateCategory",
    groups: years // brush
    ,
    label: true,
    legend: true,
    locale: locale
  }) : /*#__PURE__*/React.createElement(StackedBarChart, {
    height: 370,
    dataRaw: data,
    acc: "subtotal",
    stackedBy: "category",
    translation: translation && translation.chart ? translation.chart : null // brush
    ,
    label: true,
    legend: true,
    locale: locale
  })))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    md: 6,
    lg: !franchise ? 10 : 8,
    className: [classes.boxContainer, classes.justifiySpaceBetween].join(" ")
  }, dashboard && !franchise && !groupedByCategory && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BoxNumber, {
    variant: "percentage",
    percentage: percentages.initial_fee,
    value: dashboard.initial_fee,
    title: "Initial Fee",
    locale: locale
  }), /*#__PURE__*/React.createElement(BoxNumber, {
    variant: "percentage",
    percentage: percentages.recurring_fee,
    value: dashboard.recurring_fee,
    title: "Recurring Fee",
    locale: locale
  })), dashboard && (franchise || !franchise && groupedByCategory) && !compareYears && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BoxNumber, {
    variant: "percentage",
    percentage: percentages.events,
    value: dashboard.events,
    title: translation && translation.dashboard.events ? translation.dashboard.events : "Events",
    locale: locale
  }), /*#__PURE__*/React.createElement(BoxNumber, {
    variant: "percentage",
    percentage: percentages.campus,
    value: dashboard.campus,
    title: translation && translation.dashboard.campus ? translation.dashboard.campus : "Campus",
    locale: locale
  }), /*#__PURE__*/React.createElement(BoxNumber, {
    variant: "percentage",
    percentage: percentages.academies,
    value: dashboard.academies,
    title: translation && translation.dashboard.academies ? translation.dashboard.academies : "Academies",
    locale: locale
  })), dashboard && !compareYears && /*#__PURE__*/React.createElement(BoxNumber, {
    variant: "percentage",
    percentage: percentages.other,
    value: dashboard.other,
    title: translation && translation.dashboard.other ? translation.dashboard.other : "Other",
    locale: locale
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    md: 6,
    lg: !franchise ? 2 : 4,
    className: [classes.boxContainer, classes.justifiySpaceAround].join(" ")
  }, dashboard && !compareYears && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BoxNumber, {
    variant: "regular",
    value: dashboard.pending,
    title: translation && translation.dashboard.pending ? translation.dashboard.pending : "Pending",
    locale: locale
  })), dashboard && !compareYears && dashboard.overdue ? /*#__PURE__*/React.createElement(BoxNumber, {
    variant: "regular",
    value: dashboard.overdue,
    title: translation && translation.dashboard.overdue ? translation.dashboard.overdue : "Overdue (tax included)",
    locale: locale
  }) : null)));
};

export { InvoicesData };